import React from "react";
import { useAuth } from "@/App";
import UserLayout from "@/components/layouts/UserLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { User } from "lucide-react";
import KYCForm from "@/components/KYCForm";

const UserProfile = () => {
  const { user } = useAuth();

  return (
    <UserLayout title="Profile">
      {/* Profile Info */}
      <Card className="border-0 shadow-sm mb-6">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <User className="w-5 h-5 text-primary-600" />
            Account Information
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <Label className="text-gray-500">Name</Label>
                <p className="font-medium text-gray-900">{user?.name}</p>
              </div>
              <div>
                <Label className="text-gray-500">Mobile</Label>
                <p className="font-medium text-gray-900">{user?.mobile}</p>
              </div>
              <div>
                <Label className="text-gray-500">Email</Label>
                <p className="font-medium text-gray-900">
                  {user?.email || "Not provided"}
                </p>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <Label className="text-gray-500">Referral Code</Label>
                <p className="font-mono font-bold text-primary-600">
                  {user?.referral_code}
                </p>
              </div>
              <div>
                <Label className="text-gray-500">Account Status</Label>
                <Badge
                  className={
                    user?.is_verified
                      ? "bg-green-100 text-green-700"
                      : "bg-yellow-100 text-yellow-700"
                  }
                >
                  {user?.is_verified ? "Verified" : "Not Verified"}
                </Badge>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Full KYC */}
      <KYCForm role="user" />
    </UserLayout>
  );
};

export default UserProfile;
